module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp3_9005.14d66aa6.png";